<template>
  <footer class="text-center p-3">

          <a v-if="lon && lat"  :href="`https://maps.google.com/?q=${lat},${lon}`" target="_blank"> Мое место расположение</a>
  </footer>
</template>
<script>
export default {
    data: () => ({
    lon: null,
    lat: null,
  }),
     mounted(){
          this.$getLocation({})
                .then(coordinates => {
                  console.log(coordinates);
                this.lat = coordinates.lat;
                this.lon = coordinates.lng;
          });
   },
};
</script>
<style>
</style>
